import { render, staticRenderFns } from "./zhiweiIndex.vue?vue&type=template&id=273f2b42&scoped=true&"
import script from "./zhiweiIndex.vue?vue&type=script&lang=js&"
export * from "./zhiweiIndex.vue?vue&type=script&lang=js&"
import style0 from "./zhiweiIndex.vue?vue&type=style&index=0&id=273f2b42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273f2b42",
  null
  
)

export default component.exports